var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputWithAction',{attrs:{"icon":'search',"showActionButton":true,"isLoading":_vm.loadingNewBrand,"placeHolderText":_vm.$t('bvs.placeholder')},on:{"do-something":function($event){return _vm.searchBrand($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }